module.exports = __webpack_public_path__ + "static/media/twu.89e5d57d.jpg";